import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { CampaignGroupFormValues } from "src/models/CampaignGroup.model";
import CampaignGroupForm from "../Layouts/CampaignGroupForm";
import {
  useEditCampaignGroupMutation,
  useViewCampaignGroupByIdQuery,
} from "src/services/CampaignGroup";
import { showToast } from "src/utils/showToaster";
import { CircularProgress } from "@mui/material";
type Props = {
  onClose: () => void;
  campaignGroupId: string;
};

const EditCampaignGroupFormWrapper = ({ onClose, campaignGroupId }: Props) => {
  const [campaignData, setCampaignData] = useState<any>();

  const [editCampaignGroup] = useEditCampaignGroupMutation();
  const { data, isLoading, isFetching } =
    useViewCampaignGroupByIdQuery(campaignGroupId);

  useEffect(() => {
    if (!isFetching && !isLoading) {
      setCampaignData(data?.data?.[0]);
    }
  }, [isFetching, isLoading, data]);
  // Form Initial Values
  const initialValues: CampaignGroupFormValues = {
    campaignGroupName: campaignData?.campaignGroupName || "",
    channelLabel: campaignData?.channelId || "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    campaignGroupName: string().required("Please campaign group name"),
    channelLabel: string().required("Please select channel"),
  });

  // Handle Submit
  const handleSubmit = (
    values: CampaignGroupFormValues,
    { setSubmitting, resetForm }: FormikHelpers<CampaignGroupFormValues>
  ) => {
    const formattedValues = {
      campaignGroupName: values?.campaignGroupName,
      channelId: values?.channelLabel,
    };
    editCampaignGroup({
      body: formattedValues,
      id: campaignGroupId,
    }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <CampaignGroupForm formikProps={formikProps} onClose={onClose} />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditCampaignGroupFormWrapper;
